/**
 * Degree API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const degreeApi = {

    // 차수 목록(Get degree list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online
    guestLearnOnlineList(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online`, params)
    },

    // 차수 카테고리 목록(Get category degree list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-categorization
    guestLearnOnlineCategoryList(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/categorization`, params)
    },

    // 차수 기본정보(Get degree basic information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-fetch-detail
    guestLearnOnlineViewBasic(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}`)
    },

    // 학습개요(Get degree summery information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-detail-summery
    guestLearnOnlineViewSummery(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/summery`, params)
    },

    // 기간정책(Get degree period information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-policy-period
    guestLearnOnlineViewPeriod(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/policy/period`)
    },

    // 수료정책(Get degree completion information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-policy-completion
    guestLearnOnlineViewCompletion(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/policy/completion`)
    },

    // 포인트(Get degree point information)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-policy-completion
    guestLearnOnlineViewPoint(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/policy/point`)
    },

    // 과정목록(Get degree courses list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-resource-courses
    guestLearnOnlineViewCourses(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/courses`)
    },

    // 시험목록(Get degree exams list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-resource-exams
    guestLearnOnlineViewExams(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/exams`)
    },

    // 만족도 설문 목록(Get degree surveys list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-resource-surveys
    guestLearnOnlineViewSurveys(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/surveys`)
    },

    // 학습 미션(Get degree missions list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-resource-mission
    guestLearnOnlineViewMission(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/mission`)
    },

    // 리뷰 요약(Get degree review summary)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-review-summary
    guestLearnOnlineViewReviewSummary(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/review/summary`)
    },

    // 리뷰 목록(Get degree review list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-review-fetch
    guestLearnOnlineViewReview(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/review`, params)
    },

    // 배지 목록(Get degree badges list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-badges
    guestLearnOnlineViewBadges(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/badges`)
    },

    // 인증서 목록(Get degree certificates list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-badges
    guestLearnOnlineViewCertificates(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/certificates`)
    },

    // 스킬셋(Get degree skillset list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-badges
    guestLearnOnlineViewSkillset(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/skillset`)
    },

    // 미리보기(Get degree preview inforamtion)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest_online_degree.html#resources-guest-degree-online-resource-preview
    guestLearnOnlineViewPreview(params) {
        return httpService.get(`/guest/${BRAND_CODE}/learn/online/${params.degreeId}/preview`)
    },
}

// export const 
export default degreeApi